var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingTripsMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wall-clock 1",
    clipPath: "url(#clip0_1855_9519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5887 13.0594C15.3002 12.8448 14.8924 12.9047 14.6778 13.1931C14.5598 13.3518 14.4335 13.5074 14.3024 13.6557C14.0643 13.9251 14.0895 14.3365 14.3589 14.5747C14.4828 14.6842 14.6366 14.738 14.7899 14.738C14.9699 14.738 15.1492 14.6636 15.2779 14.5181C15.4331 14.3425 15.5827 14.1582 15.7225 13.9703C15.9371 13.6818 15.8772 13.274 15.5887 13.0594Z",
    fill: "#DFE5EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.6776 10.0053C16.3265 9.9288 15.9794 10.1516 15.903 10.5029C15.8609 10.6962 15.81 10.8898 15.7517 11.0785C15.6456 11.422 15.838 11.7865 16.1815 11.8927C16.2456 11.9125 16.3103 11.9219 16.374 11.9219C16.652 11.9219 16.9094 11.7424 16.9958 11.4628C17.065 11.2389 17.1253 11.0091 17.1753 10.7799C17.2517 10.4286 17.0289 10.0818 16.6776 10.0053Z",
    fill: "#DFE5EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.4551 15.1442C12.2822 15.2407 12.1032 15.3309 11.9232 15.4122C11.5955 15.5602 11.4498 15.9458 11.5978 16.2735C11.7065 16.5143 11.9434 16.6568 12.1915 16.6568C12.2811 16.6568 12.3721 16.6382 12.4591 16.5989C12.6727 16.5024 12.8849 16.3955 13.0898 16.2811C13.4038 16.1058 13.5162 15.7092 13.3409 15.3953C13.1656 15.0814 12.769 14.969 12.4551 15.1442Z",
    fill: "#DFE5EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.34901 3.79167V8.73034L5.96167 11.1176C5.70744 11.3719 5.70744 11.7841 5.96167 12.0383C6.08882 12.1655 6.25539 12.229 6.42205 12.229C6.58866 12.229 6.75529 12.1655 6.88244 12.0383L9.46043 9.46035C9.5825 9.33828 9.65109 9.17266 9.65109 9V3.79167C9.65109 3.4321 9.35962 3.14062 9.00005 3.14062C8.64048 3.14062 8.34901 3.4321 8.34901 3.79167Z",
    fill: "#DFE5EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.6823 2.06673C16.3227 2.06673 16.0313 2.3582 16.0313 2.71777V4.52559C14.5159 2.14902 11.8695 0.666992 9.00002 0.666992C6.77411 0.666992 4.68143 1.53382 3.10744 3.10775C1.53352 4.68174 0.666687 6.77441 0.666687 9.00033C0.666687 11.2262 1.53352 13.3189 3.10744 14.8929C4.68143 16.4668 6.77411 17.3337 9.00002 17.3337C9.00552 17.3337 9.01083 17.333 9.0163 17.3328C9.02177 17.333 9.02707 17.3337 9.03257 17.3337C9.26721 17.3337 9.50416 17.3238 9.7369 17.3043C10.0952 17.2743 10.3613 16.9595 10.3314 16.6012C10.3013 16.2429 9.98697 15.9766 9.62824 16.0068C9.4315 16.0232 9.23111 16.0316 9.03257 16.0316C9.02707 16.0316 9.02177 16.0323 9.0163 16.0324C9.01083 16.0323 9.00552 16.0316 9.00002 16.0316C5.12297 16.0316 1.96877 12.8774 1.96877 9.00033C1.96877 5.12328 5.12297 1.96908 9.00002 1.96908C11.4987 1.96908 13.7968 3.30088 15.0526 5.4196H13.2625C12.9029 5.4196 12.6114 5.71107 12.6114 6.07064C12.6114 6.43021 12.9029 6.72168 13.2625 6.72168H15.25C15.6465 6.72168 16.0174 6.61025 16.3333 6.41722C16.3536 6.40563 16.3731 6.39316 16.3917 6.37972C16.9583 6.00697 17.3334 5.36579 17.3334 4.63835V2.71777C17.3334 2.3582 17.0419 2.06673 16.6823 2.06673Z",
    fill: "#DFE5EB"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1855_9519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 16.6667,
    fill: "white",
    transform: "translate(0.666687 0.666992)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingTripsMenu);
export default __webpack_public_path__ + "static/media/PendingTripsMenu.0df60ece867c8754f426e43a298ca7e0.svg";
export { ForwardRef as ReactComponent };